// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/printed-placements/printed-placements.mdl.scss
// module id = 986
// module chunks = 0